const feiche = [{
  desc: '非车获取险种类型',
  options: {
    url: '/insurancefc/getInsurancetypeCodeList',
    method: 'get'
  }
}, {
  desc: '非车产品方案查询',
  options: {
    url: '/insurancefc/queryProductPlanFc',
    method: 'post'
  }
}, {
  desc: '保单id查询',
  options: {
    url: '/insurancefc/queryInsuranceinfoNew',
    method: 'get',
    argsParams: true
  },
  vuex: false
}, {
  desc: '保单号查询',
  options: {
    url: '/insurancefc/queryInsuranceinfoNewByNo',
    method: 'get',
    argsParams: true
  }
}, {
  desc: '保单录入',
  options: {
    url: '/insurancefc/addInsuranceinfoNew',
    method: 'post'
  }
}, {
  desc: '保单列表',
  options: {
    url: '/insurancefc/queryPageInsuranceinfoNew',
    method: 'post'
  }
}, {
  desc: '更新保单',
  options: {
    url: '/insurancefc/updateInsuranceinfoNew',
    method: 'put'
  }
}, {
  desc: '导入',
  options: {
    url: '/insurancefc/leading',
    method: 'post'
  }
}, {
  desc: '批量删除',
  options: {
    url: '/insurancefc/deleteInsuranceinfoNew',
    method: 'delete'
  }
}, {
  desc: '非车产品方案查询',
  options: {
    url: '/insurancefc/queryProductPlanFcAll',
    method: 'post'
  }
}, {
  desc: '分页查询批次信息',
  options: {
    url: '/insurancefc/queryPagePolicyFcBranchNew',
    method: 'post'
  }
}, {
  desc: '非车政策变更状态',
  options: {
    url: '/newPolicyBatch/fcChangeStatus',
    method: 'post'
  }
}, {
  desc: '添加批次信息',
  options: {
    url: '/insurancefc/addPolicyFcBranchNew',
    method: 'post'
  }
}, {
  desc: '更新批次信息',
  options: {
    url: '/insurancefc/updatePolicyFcBranchNew',
    method: 'post'
  }
}, {
  desc: '政策导出',
  options: {
    url: '/insurancefc/policyFcExport',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '导出日周月报表',
  options: {
    url: '/report/exportDwmReport',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '查询非车政策批次信息通过详情id',
  options: {
    url: '/insurancefc/queryPolicyFcBranchNewByDateil',
    method: 'post'
  }
}, {
  desc: '查询车险政策批次信息通过详情id',
  options: {
    url: '/newPolicyBatch/queryPolicyByInsRegexId',
    method: 'get'
  }
}, {
  desc: '保单批量删除',
  options: {
    url: '/insurancefc/batchDeleteInsurance',
    method: 'post'
  }
}, {
  desc: '保单批量全选',
  options: {
    url: '/insurancefc/checkAll',
    method: 'post'
  }
}, {
  desc: '通过id查询业务员',
  options: {
    url: '/customer/getCustomerById',
    method: 'post',
    formdata: true
  }
}, {
  desc: '查询全部地区',
  options: {
    url: '/Home/GetProvince',
    method: 'post',
    baseURL: '/cxv3'
  }
}, {
  desc: '查询本省地区',
  options: {
    url: '/Home/GetProvinceCity',
    method: 'post',
    baseURL: '/cxv3',
    formdata: true
  }
}, {
  desc: '查询指定地区',
  options: {
    url: '/Home/GetCityDistrict',
    method: 'post',
    baseURL: '/cxv3',
    formdata: true
  }
}, {
  desc: '查询 产品-方案-险种',
  options: {
    url: '/insurancefc/queryProductList',
    method: 'post'
  }
  // vuex: true
}, {
  desc: '添加 产品-方案 信息',
  options: {
    url: '/insurancefc/addCustomProduct',
    method: 'post'
  }
}, {
  desc: '添加 产品-方案 信息',
  options: {
    url: '/insurancefc/updateCustomProduct',
    method: 'post'
  }
}, {
  desc: '批量导入产品信息',
  options: {
    url: '/insurancefc/importProductList',
    method: 'post'
  }
}, {
  desc: '查询多个原保单号',
  options: {
    url: '/insurancefc/queryInsuranceinfoNewByNoNew',
    method: 'get',
    argsParams: true
  }
}, {
  desc: '产品管理-系统管理',
  options: {
    url: '/insurancefc/queryPageProductList',
    method: 'post'
  }
}, {
  desc: '保单批量删除检查(新)',
  options: {
    url: '/insurancefc/batchCheckDeleteInsurance',
    method: 'post'
  }
}, {
  desc: '非车订单列表 - 分销',
  options: {
    url: '/adminOrder/supplyOrderPage',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '非车订单列表',
  options: {
    url: '/adminOrder/orderPage',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '非车订单列表-获取非车投保二维码',
  options: {
    url: '/insureUrlData/createQrCodeForOrderDetail',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '非车批单列表',
  options: {
    url: '/adminOrder/orderPageForCorrectInsurance',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '非车订单详情',
  options: {
    url: '/adminOrder/orderDetail',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '手动编辑订单',
  options: {
    url: '/adminOrder/edit',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '订单导出',
  options: {
    url: '/adminOrder/exportOrder',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure',
    responseType: 'arraybuffer'
  }
}, {
  desc: '非车订单归集查询',
  options: {
    url: '/orderlog/queryLog',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '非车订单保单列表',
  options: {
    url: '/adminOrder/policyList',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '非车订单保单退保接口',
  options: {
    url: '/orderinsure/order/surrenderOrder',
    method: 'post'
  }
}, {
  desc: '非车订单导入接口',
  options: {
    url: '/adminOrder/importOrder',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '修改订单展示页信息',
  options: {
    url: '/adminOrder/orderEditInfo',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '非车订单订单-保单退款接口',
  options: {
    url: '/adminOrder/applyRefund',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '查询商户商品列表',
  options: {
    url: '/shoping/commodifyList',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-commmodify'
  }
}, {
  desc: '查询商户商品列表',
  options: {
    url: '/insureUrlData/commodifyList',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '产品-投保地址',
  options: {
    url: '/insureUrlData/createPersonalQrCodeForPc',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure/'
  }
}, {
  desc: '获取商户名下产品列表',
  options: {
    url: '/productFc/queryProductNonVehicleInfosIgnoreStatus',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-platform/'
  }
}, {
  desc: '保单同步',
  options: {
    url: '/mq/pushOrderToSaas',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '获取投保链接',
  options: {
    url: '/cpsOrder/jumpUrl',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '退款',
  options: {
    url: '/order/applyRefund',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '团险订单列表',
  options: {
    url: '/adminOrder/orderPageForGroupInsurance',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '获取订单电子保单链接',
  options: {
    url: '/cpsOrder/queryEPolicy',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '获取订单电子发票链接',
  options: {
    url: '/cpsOrder/queryEInvoice',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '删除订单',
  options: {
    url: '/cpsOrder/delete',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '获取团险保单列表',
  options: {
    url: '/adminOrder/queryPolicyListForGroupInsurance',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '非车订单-保单退保试算接口',
  options: {
    url: '/huabaoInsure/order/applyPreSurrender',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '非车订单-保单退保接口',
  options: {
    url: '/huabaoInsure/order/applySurrender',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '非车订单-保单申请批改接口',
  options: {
    url: '/huabaoInsure/order/applyEndorse',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '非车订单-电子保单接口',
  options: {
    url: '/order/queryEPolicy',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '非车详情-去保司系统同步电子保单',
  options: {
    url: '/huabaoInsure/queryEPolicy',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '非车详情-银行列表',
  options: {
    url: '/order/bankList',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '非车详情-开户行',
  options: {
    url: '/order/bankCnapsList',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '非车详情-申请退保',
  options: {
    url: '/jinHeInsure/order/applySurrenderOrder',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '获取订单电子保单链接 - 锦和',
  options: {
    url: '/jinHeInsure/order/queryEPolicy',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '获取订单电子发票链接 - 锦和',
  options: {
    url: '/jinHeInsure/order/queryEInvoice',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '新增运输单号',
  options: {
    url: '/order/supplyTrackNumber',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '上传电子发票',
  options: {
    url: '/order/addFile',
    method: 'post',
    baseURL: '/insapi/v3/youbaolian-product-insure'
  }
}, {
  desc: '分销商列表',
  options: {
    url: '/insurancefc/querySupplierInfoList',
    method: 'get'
  }
}
]

export default feiche



// WEBPACK FOOTER //
// ./src/api/feiche.js